import { useQuery } from "@tanstack/react-query";
import { eventsService, type Event } from "@/services/events.service";

interface UpcomingEventsResult {
  events: Event[];
  total: number;
}

export const useUpcomingEvents = (days: number | null = 30, limit = 6, enabled = true) => {
  // Include today's local date in the cache key so it rolls over at local
  // midnight, matching the service's local start-of-day window (a UTC date
  // rolled at 5 PM Pacific). Persisted (cachePersistence): same-day reopens
  // paint the row from disk.
  const today = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD, local
  const daysKey = days ?? "open-ended";

  return useQuery<UpcomingEventsResult>({
    queryKey: ["events", "upcoming", daysKey, limit, today],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const response = await eventsService.getUpcomingEvents(days);
      const events = (response.events ?? []).slice(0, limit);
      return {
        events,
        total: response.total ?? events.length,
      };
    },
  });
};
